import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const startPricingPlanChargingProcess = async (selectedDomain: string, planId: number, isDirect: boolean = false): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `billing/pricing-plan`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        params: {
            planId,
            isDirect
        },
        isEncrypted: true,
    });
}